import { Field } from 'components/Wizards/Field/Field'
import { Age } from './Age'
import { Gender } from './Gender'
import cx from 'classnames'
import Styles from './AudiencePreferences.module.scss'
import { OptionalFieldProps } from '../types'
import { HeadingLevel } from 'almanac-ui/Heading/Heading'

type Props = {
  minAge?: number
  maxAge?: number
  gender?: string
  onMinAgeUpdate: (age: number | undefined) => void
  onMaxAgeUpdate: (age: number | undefined) => void
  onGenderUpdate: (gender: string) => void
  headingLevel?: HeadingLevel
  labelColor?: string
  className?: string
} & OptionalFieldProps

const AudiencePreferences = ({
  fieldProps,
  minAge,
  maxAge,
  gender,
  onMinAgeUpdate,
  onMaxAgeUpdate,
  onGenderUpdate,
  headingLevel = 3,
  labelColor,
  className,
}: Props) => {
  return (
    <Field
      label="Who you're speaking to"
      headingLevel={headingLevel}
      data-testid="audience-preferences"
      labelColor={labelColor}
      {...fieldProps}
    >
      <div className={cx(Styles.fields, className)}>
        <div className={Styles.field}>
          <Age
            minAge={minAge}
            maxAge={maxAge}
            onMinAgeUpdate={onMinAgeUpdate}
            onMaxAgeUpdate={onMaxAgeUpdate}
            labelColor={labelColor}
          />
        </div>
        <div className={cx(Styles.field, Styles.genderField)}>
          <Gender gender={gender} onUpdate={onGenderUpdate} labelColor={labelColor} />
        </div>
      </div>
    </Field>
  )
}

export { AudiencePreferences }
